import { ITableRowData, IColumn } from "../../../shared/components/normal-table/normal-table";
import { createUUID, appendixOfy1 } from "../../../shared/utils/utils";

export const inProductionOptions = [
  { name: "Test", id: "test" },
  { name: "Production", id: "production" },
];

export const productionModalCols: IColumn[] = [
  {
    key: "state",
    displayName: "State",
    dataType: {
      type: "enumeration",
      values: inProductionOptions,
    },
    required: false
  },
  {
    key: "comment",
    displayName: "Note",
    dataType: {
      type: "textarea"
    },
    required: true
  }
];

export const defaultLayout = () => {
  const headerID = createUUID();
  const tabsWidgetID = createUUID();

  const chartTabID = createUUID();
  const resultTabID = createUUID();
  const modelTabID = createUUID();
  const sourceDataTabID = createUUID();
  const historyTrendsTabID = createUUID();

  const chartWidgetID = createUUID();
  const resultWidgetID = createUUID();
  const modelWidgetID = createUUID();
  const sourceDataWidgetID = createUUID();
  const historyTrendsWidgetID = createUUID();

  return {
    layout: [
      {
        w: 36,
        h: 16,
        x: 0,
        y: 9,
        i: tabsWidgetID,
        minW: 0,
        moved: false,
        static: false,
      },
      {
        w: 36,
        h: 3,
        x: 0,
        y: 0,
        i: headerID,
        moved: false,
        static: false,
      }
    ],
    layoutItems: [
      {
        optionName: "Tabs Widget",
        id: tabsWidgetID,
        text: "",
        settings: undefined,
        steps: [
          {
            key: chartTabID,
            name: "Chart",
            layout: [
              {
                w: 36,
                h: 12,
                x: 0,
                y: 0,
                i: chartWidgetID,
                minW: 0,
                moved: false,
                static: false,
              },
            ],
            layoutItems: [
              {
                optionName: "Custom widget",
                id: chartWidgetID,
                text: "",
                steps: [],
                selectedStepId: "",
                settings: {
                  widget_type: "chart",
                  source: "report_data",
                  selectedColumns: [
                    "tt_transaction_count_tp",
                    "tt_transaction_count_tn_frac",
                    "tt_transaction_amount_tp",
                    "tt_consolidated_count_accuracy",
                  ],
                  customColumnsColors: {
                    tt_transaction_count_tp: "#97c908",
                    tt_transaction_count_tn_frac: "#6e67ee",
                    tt_transaction_amount_tp: "#8a3ae7",
                    tt_consolidated_count_accuracy: "#396a72"
                  }
                },
              },
            ],
          },
          {
            key: resultTabID,
            name: "Results",
            layout: [
              {
                w: 36,
                h: 10,
                x: 0,
                y: 0,
                i: resultWidgetID,
                minW: 0,
                moved: false,
                static: false,
              },
            ],
            layoutItems: [
              {
                optionName: "Custom widget",
                text: "",
                id: resultWidgetID,
                steps: [],
                settings: {
                  widget_type: "table",
                  source: "report_data",
                  selectedColumns: [
                    "threshold",
                    "tt_transaction_count_tp",
                    "tt_transaction_count_tn_frac",
                    "tt_transaction_amount_tp",
                    "tt_consolidated_count_accuracy",
                  ],
                },
              },
            ],
          },
          {
            key: modelTabID,
            name: "Model",
            layout: [
              {
                w: 36,
                h: 10,
                x: 0,
                y: 0,
                i: modelWidgetID,
                minW: 0,
                moved: false,
                static: false,
              },
            ],
            layoutItems: [
              {
                optionName: "Custom widget",
                text: "",
                id: modelWidgetID,
                steps: [],
                settings: {
                  widget_type: "table",
                  source: "model",
                  selectedColumns: ["technical_variable_name", "technical_variable_definition", "weight"],
                },
              },
            ],
          },
          {
            key: sourceDataTabID,
            name: "Source Data",
            layout: [
              {
                w: 36,
                h: 10,
                x: 0,
                y: 0,
                i: sourceDataWidgetID,
                minW: 0,
                moved: false,
                static: false,
              },
            ],
            layoutItems: [
              {
                optionName: "Custom widget",
                text: "",
                id: sourceDataWidgetID,
                steps: [],
                settings: {
                  widget_type: "table",
                  source: "source_data",
                  selectedColumns: [
                    "input_field_name",
                    "field_name",
                    "field_type",
                    "SGA_data_label",
                    "empty_field_count",
                    "nan_count",
                    "null_count",
                    "unique_value_count",
                  ],
                },
              },
            ],
          },
          {
            key: historyTrendsTabID,
            name: "History Trends",
            layout: [
              {
                w: 36,
                h: 10,
                x: 0,
                y: 0,
                i: historyTrendsWidgetID,
                minW: 0,
                moved: false,
                static: false,
              },
            ],
            layoutItems: [
              {
                optionName: "Custom widget",
                id: historyTrendsWidgetID,
                text: "",
                steps: [],
                selectedStepId: "",
                settings: {
                  widget_type: "chart",
                  source: "history",
                  selectedThreshold: "0.1",
                  selectedColumns: [
                    "alert_amount_tp",
                    "consolidated_count_f_0_5_score",
                    "entity_amount_fp_frac",
                    "transaction_amount_fp_frac"
                  ],
                  customColumnsColors: {
                    alert_amount_tp: "#396a72",
                    consolidated_count_f_0_5_score: "#8a3ae7",
                    entity_amount_fp_frac: "#6e67ee",
                    transaction_amount_fp_frac: "#97c908"
                  }
                },
              },
            ],
          },
        ],
        selectedStepId: chartTabID,
      },
      {
        optionName: "Text",
        id: headerID,
        text: "Default Header",
        textType: "header",
        settings: undefined,
        steps: [],
        selectedStepId: "",
      }
    ],
    lock: true,
  };
};

export const populateHistoryObj = (history_trend_data: ITableRowData[], getResultsColsData?: any) => { // eslint-disable-line
  const prepareDatasetsList = [];

  if (getResultsColsData && history_trend_data) {
    for (const [key, value] of Object.entries(getResultsColsData?.rows?.columns)) {
      const defineAxios = appendixOfy1.find((appendixVal) => key.includes(appendixVal));

      prepareDatasetsList.push({
        label: value,
        data: history_trend_data.map((row: ITableRowData) => row?.[key]),
        borderColor: "#c4718e", 
        backgroundColor: "#c4718e", 
        key: key,
        yAxisID: defineAxios ? "y1" : "y",
      });
    }
  }

  return {
    labels: history_trend_data? history_trend_data.map((x: ITableRowData) => (x.timeframe ? x.timeframe : 0)) : [],
    datasets: prepareDatasetsList
  };
};

interface StringMap {
  [key: string]: string;
}

export const historyObjWithDefColors: StringMap = {
  alerted_case_count_sum_per_timeframe: "#8ecae6",
  all_amount_sum_per_timeframe: "#673ab7",
  all_case_count_per_timeframe: "#65AFFF",
  labelled_amount_sum_per_timeframe: "#c8b64a",
  labelled_case_count_per_timeframe: "#fb8500",
  positive_case_count_per_timeframe: "#4754fc",
  recall_amount: "#3ceb98",
  tp_alerted_amount_sum_per_timeframe: "#b7703a",
  tp_amount_sum_per_timeframe: "#7f96c8",
  tp_case_count_per_timeframe: "#b0c87f",
  tp_labelled_case_amount_ratio: "#ced766",
  tp_labelled_case_count_ratio: "#4caf50",
  tp_positive_case_count_ratio: "#1B2845",
};

export const resultsObjWithDefColors: StringMap = {
  tt_alert_count_tp: "#533882",
  tt_alert_count_fp: "#8a4e21",
  tt_alert_count_fn: "#2f563d",
  tt_alert_count_tn: "#13e685",
  tt_alert_count_p: "#3e2c96",
  tt_alert_count_tp_frac: "#45b28b",
  tt_alert_count_fp_frac: "#319f5f",
  tt_alert_count_fn_frac: "#7b05f8",
  tt_alert_count_tn_frac: "#133975",
  tt_alert_count_p_frac: "#7afc31",
  tt_alert_count_f_0_5_score: "#3ccc03",
  tt_alert_count_f_1_0_score: "#ea4acd",
  tt_alert_count_f_2_0_score: "#e2d412",
  tt_alert_count_accuracy: "#d88366",
  tt_alert_count_precision: "#27f5b2",
  tt_alert_count_recall: "#2466dd",
  tt_alert_count_specificity: "#494aff",
  tt_alert_count_fpr: "#25833b",
  tt_alert_amount_tp: "#65e93f",
  tt_alert_amount_fp: "#4738e1",
  tt_alert_amount_fn: "#526462",
  tt_alert_amount_tn: "#7cf317",
  tt_alert_amount_tp_frac: "#77d9a7",
  tt_alert_amount_fp_frac: "#218b81",
  tt_alert_amount_fn_frac: "#fabc74",
  tt_alert_amount_tn_frac: "#501015",
  tt_transaction_count_tp: "#fb8500",
  tt_transaction_count_fp: "#7439dc",
  tt_transaction_count_fn: "#1B2845",
  transaction_count_tn: "#f0c85a",
  tt_transaction_count_p: "#8ecae6",
  tt_transaction_count_tp_frac: "#ffe81c",
  tt_transaction_count_fp_frac: "#b7703a",
  tt_transaction_count_fn_frac: "#353754",
  tt_transaction_count_tn_frac: "#65AFFF",
  tt_transaction_count_p_frac: "#3ceb98",
  tt_transaction_count_f_0_5_score: "#4caf50",
  tt_transaction_count_f_1_0_score: "#ced766",
  tt_transaction_count_f_2_0_score: "#b0c87f",
  tt_transaction_count_accuracy: "#7f96c8",
  tt_transaction_count_precision: "#4754fc",
  transaction_count_recall: "#c8b64a",
  tt_transaction_count_specificity: "#673ab7",
  tt_transaction_count_fpr: "#808455",
  tt_transaction_amount_tp: "#2630be",
  tt_transaction_amount_fp: "#ff9800",
  tt_transaction_amount_fn: "#e91e63",
  tt_transaction_amount_tn: "#672520",
  tt_transaction_amount_tp_frac: "#009688",
  tt_transaction_amount_fp_frac: "#9c27b0",
  tt_transaction_amount_fn_frac: "#c25128",
  tt_transaction_amount_tn_frac: "#206744",
  tt_consolidated_count_tp: "#cddc39",
  tt_consolidated_count_fp: "#a40038",
  tt_consolidated_count_fn: "#b89aa4",
  tt_consolidated_count_tn: "#ff6d6d",
  tt_consolidated_count_p: "#b7b7b7",
  tt_consolidated_count_tp_frac: "#795548",
  tt_consolidated_count_fp_frac: "#7cbc98",
  tt_consolidated_count_fn_frac: "#3a2067",
  tt_consolidated_count_tn_frac: "#003c7c",
  tt_consolidated_count_p_frac: "#3a5dab",
  tt_consolidated_count_f_0_5_score: "#4f513b",
  tt_consolidated_count_f_1_0_score: "#2c3007",
  tt_consolidated_count_f_2_0_score: "#847287",
  tt_consolidated_count_accuracy: "#2b9881",
  tt_consolidated_count_precision: "#799ab5",
  tt_consolidated_count_recall: "#126f9c",
  tt_consolidated_count_specificity: "#107414",
  tt_consolidated_count_fpr: "#2e4a47",
  tt_consolidated_amount_tp: "#ffc107",
  tt_consolidated_amount_fp: "#7ed913",
  tt_consolidated_amount_fn: "#673ab7",
  tt_consolidated_amount_tn: "#8d2c0d",
  tt_consolidated_amount_tp_frac: "#2196f3",
  tt_consolidated_amount_fp_frac: "#d1b45f",
  tt_consolidated_amount_fn_frac: "#7b5d07",
  tt_consolidated_amount_tn_frac: "#cca191",
  tt_entity_count_tp: "#de638d",
  tt_entity_count_fp: "#c9bd58",
  tt_entity_count_fn: "#54851c",
  tt_entity_count_tn: "#2774b0",
  entity_count_p: "#3f05a6",
  entity_count_tp_frac: "#a2faa5",
  entity_count_fp_frac: "#093e0b",
  entity_count_fn_frac: "#0b71a3",
  entity_count_tn_frac: "#5c3a62",
  entity_count_p_frac: "#97733d",
  entity_count_f_0_5_score: "#8a94cc",
  entity_count_f_1_0_score: "#28242d",
  entity_count_f_2_0_score: "#ece287",
  entity_count_accuracy: "#b28f23",
  entity_count_precision: "#e91e63",
  entity_count_recall: "#2848ff",
  entity_count_specificity: "#fac2b0",
  entity_count_fpr: "#00e2ff",
  entity_amount_tp: "#89ff00",
  entity_amount_fp: "#8e6ec8",
  entity_amount_fn: "#282d00",
  entity_amount_tn: "#93ff16",
  entity_amount_tp_frac: "#3e4438",
  entity_amount_fp_frac: "#00093a",
  entity_amount_fn_frac: "#69eeff",
  entity_amount_tn_frac: "#992e2e",
};

export const metrics4 = [
  {
    label: "Test",
    key: "test",
  },
  {
    label: "Train",
    key: "train",
  },
  {
    label: "Ratio",
    key: "tvtr",
  },
];

export const metrics5 = [
  {
    label: "Median",
    key: "median",
  },
  {
    label: "Min",
    key: "min",
  },
  {
    label: "Max",
    key: "max",
  },
  {
    label: "Average",
    key: "avg",
  },
  {
    label: "Standard Deviation",
    key: "std",
  },
];

export const metrics6 = [
  {
    label: "Precision",
    key: "precision",
  },
  {
    label: "Recall",
    key: "recall",
  },
  {
    label: "Specificity",
    key: "specificity",
  },
];

export const coreMetrics = [
  {
    label: "Alert",
    key: "alert",
  },
  {
    label: "Transaction",
    key: "transaction",
  },
  {
    label: "Consolidated",
    key: "consolidated",
  },
  {
    label: "Entity",
    key: "entity",
  },
];

export const subCoreMetrics = [
  {
    label: "Amount",
    key: "amount",
  },
  {
    label: "Count",
    key: "count",
  },
];

export const subCoreDetailsMetrics = [
  {
    label: "TP",
    key: "tp",
  },
  {
    label: "TN",
    key: "tn",
  },
  {
    label: "P",
    key: "_p",
  },
  {
    label: "FP",
    key: "fp",
  },
  {
    label: "FN",
    key: "fn",
  },
  {
    label: "FPR",
    key: "fpr",
  },
  {
    label: "%",
    key: "frac",
  }
];

export interface IChartResultsCols {
  datasets: any, // eslint-disable-line
  labels: string[]
}

export const populateResultsObj = (report_data: ITableRowData[], getResultsColsData?: any) => { // eslint-disable-line
  const prepareDatasetsList = [];

  if (getResultsColsData && report_data) {
    for (const [key, value] of Object.entries(getResultsColsData?.rows?.columns)) {
      const defineAxios = appendixOfy1.find((appendixVal) => key.includes(appendixVal));
      prepareDatasetsList.push({
        label: value,
        data: report_data.map((row: ITableRowData) => row?.[key]),
        borderColor: "#c4718e", 
        backgroundColor: "#c4718e", 
        key: key,
        yAxisID: defineAxios ? "y1" : "y",
      });
    }
  }

  return {
    labels: report_data? report_data.map((x: ITableRowData) => (x.threshold ? x.threshold : 0)) : [],
    datasets: prepareDatasetsList
  };
};

export const resultChartDataInitial = {
  labels: [],
  datasets: [
    {
      label: "TP txns",
      data: "",
      borderColor: "rgb(60, 235, 152)",
      backgroundColor: "rgb(60, 235, 152)",
      yAxisID: "y",
    },
    {
      label: "FP txns",
      data: "",
      borderColor: "rgb(71 84 252)",
      backgroundColor: "rgb(71 84 252)",
      yAxisID: "y",
    },
    {
      label: "Fraud txns prevented",
      data: "",
      borderColor: "#65AFFF",
      backgroundColor: "#65AFFF",
      yAxisID: "y",
    },
    {
      label: "Fraud txns Amt prevented",
      data: "",
      borderColor: "#1B2845",
      backgroundColor: "#1B2845",
      yAxisID: "y",
    },
    {
      label: "Total case count",
      data: "",
      borderColor: "#fb8500",
      backgroundColor: "#fb8500",
      yAxisID: "y",
    },
    {
      label: "TP entities detected",
      data: "",
      borderColor: "#8ecae6",
      backgroundColor: "#8ecae6",
      yAxisID: "y",
    },
  ],
};
